// Helpers
import _ from 'lodash';

// Types
type $RootMenuItem = {
  icon: string;
  id: string;
  name: string;
  path: string;
};

type $SubMenuItem = {
  icon: string;
  id: string;
  name: string;
  submenu: Array<$RootMenuItem>;
};

type $MenuSpacer = {
  heading: string;
  icon?: string;
  id?: string;
  name?: string;
};

type $MenuItem = ($MenuSpacer | $RootMenuItem | $SubMenuItem) & { disabled?: boolean };

export type $Menu = Array<$MenuItem>;

export const getMenu = ({
  isSuperUser,
  RegattaId,
}: {
  isSuperUser: boolean;
  RegattaId: null | string;
}): $Menu => {
  const disabled: boolean = RegattaId === null;

  let menu: $Menu = [{
    icon: 'icon-flag',
    id: 'regattas',
    name: 'My regattas',
    path: '/regattas',
  }];

  menu = _.concat(
    menu,
    [{
      heading: 'Active regatta menu',
    }, {
      disabled,
      icon: 'icon-equalizer',
      id: 'regatta-settings',
      name: 'Regatta settings',
      path: '/regatta/settings',
    }, {
      disabled,
      icon: 'icon-pin',
      id: 'regatta-board',
      name: 'Regatta board',
      path: '/regatta/board',
    }, {
      disabled,
      icon: 'icon-list',
      id: 'regatta-entries',
      name: 'Regatta entries',
      path: '/regatta/entries',
    },
    {
      disabled,
      icon: 'icon-trophy',
      id: 'regatta-results',
      name: 'Regatta results',
      path: '/regatta/results',
    },
    // {
    //   icon: 'icon-pie-chart',
    //   id: 'regatta-result-overalls',
    //   name: 'Regatta overall results',
    //   path: '/regatta/result_overalls',
    // },
    {
      disabled,
      icon: 'icon-info',
      id: 'regatta-info',
      name: 'Regatta info',
      path: '/regatta/info',
    },
    {
      disabled,
      icon: 'icon-share',
      id: 'regatta-courses',
      name: 'Regatta courses',
      path: '/regatta/courses',
    }],
  );

  if (isSuperUser === true) {
    menu = _.concat(
      menu,
      [{
        disabled,
        icon: 'icon-folder-alt',
        id: 'regatta-logs',
        name: 'Regatta logs',
        path: '/regatta/logs',
      }],
    );
  }

  menu = _.concat(
    menu,
    [{
      heading: '',
    }, {
      icon: 'icon-organization',
      id: 'championships',
      name: 'Championships',
      path: '/championships',
    }],
  );

  menu = _.concat(
    menu,
    [{
      heading: '',
    }, {
      icon: 'icon-user',
      id: 'profile',
      name: 'Profile',
      path: '/profile',
    }],
  );

  if (isSuperUser === true) {
    const adminMenu = [{
      heading: 'Admin menu',
    }, {
      icon: 'icon-notebook',
      id: 'database',
      name: 'Database',
      submenu: [{
        icon: 'icon-check',
        id: 'entries',
        name: 'Entries',
        path: '/admin/entries',
      }, {
        icon: 'icon-calculator',
        id: 'ratings',
        name: 'Ratings',
        path: '/admin/ratings',
      }, {
        icon: 'icon-people',
        id: 'crewmwmbers',
        name: 'Crewmembers',
        path: '/admin/crewmembers',
      }],
    }, {
      icon: 'icon-docs',
      id: 'documents',
      name: 'Documents',
      path: '/admin/documents',
    }, {
      icon: 'icon-options',
      id: 'banners',
      name: 'Banners',
      path: '/admin/banners',
    }, {
      icon: 'icon-user-follow',
      id: 'payments',
      name: 'Advertisements',
      path: '/admin/advertisements',
    }, {
      icon: 'icon-bell',
      id: 'regatta_notifications',
      name: 'Notifications',
      path: '/admin/regatta_notifications',
    }, {
      icon: 'icon-note',
      id: 'custom-pages',
      name: 'Custom pages',
      path: '/admin/custom_pages',
    }, {
      icon: 'icon-grid',
      id: 'groups',
      name: 'Groups',
      path: '/admin/groups',
    }, {
      icon: 'icon-wallet',
      id: 'payments',
      name: 'Payments',
      submenu: [{
        icon: 'icon-list',
        id: 'payments-transactions',
        name: 'Transactions',
        path: '/admin/regatta_payments',
      }, {
        icon: 'icon-tag',
        id: 'payments-discount-codes',
        name: 'Discount codes',
        path: '/admin/regatta_payment_discounts',
      }],
    }, {
      icon: 'icon-flag',
      id: 'regions',
      name: 'Regions',
      path: '/admin/regions',
    }, {
      icon: 'icon-people',
      id: 'admins',
      name: 'Admins',
      path: '/admin/admins',
    }];

    menu = _.concat(
      menu,
      adminMenu,
    );
  }

  return _.get(
    {
      menu,
    },
    'menu',
  );
};
